export default __webpack_public_path__ + "static/media/notification-icon.222f4009.svg";